import type { CompanyStatus } from '@pole-api/lib-integration-dadata-api/lib/models/CompanyStatus'
import type { IOrganizationProfile } from '@/logic/auth/interfaces'

export const emptyOrganizationProfile: IOrganizationProfile = {
  organization: {
    inn: null,
    ogrn: null,
    kpp: null,
    okved: null,
    okpo: null,
    director: null,
    address: null,
    name: null,
    additionalOkveds: [],
    state: null,
    deliveryBasesData: [],
    capitalValue: null,
    financeYear: null,
    financeIncome: null,
  },
  additionalInformation: {
    employees: null,
    activity: null,
  },
}

export const ORGANIZATION_STATUSES_ACCEPTABLE_FOR_REGISTRATION: CompanyStatus[] = ['ACTIVE', 'REORGANIZING']
